module.exports = __webpack_public_path__ + "img/more-icon.0cc7ed7d.svg";